export enum InfoBoxType {
  Normal = 'normal',
  Warning = 'warning',
}
